import styled from 'styled-components';
import { BdsPaper } from 'blip-ds/dist/blip-ds-react';
import colors from '_colors.module.scss';

export const Container = styled(BdsPaper)`
  padding: 1.5rem;
  margin: 2.5rem auto;
  border-radius: 1rem;
  justify-self: center;
  max-width: 59rem;
  width: 100%;
  background-color: ${colors.Surface0};
  box-shadow: none;
`;
